module.exports = __webpack_public_path__ + "static/graphicdesign-432c72bdce19478503aac9b4e8ef7f97.jpg";